// Acciones asincronas que pueden llamar una inforrmacion
import {
  borraEstancia,
  getEstancias,
  getInvestigators,
  getSemestres,
  insertSemestres,
  updateSemestres,
  updateInvestigator,
  insertInvestigator,
  deleteInvestigator,
  validaRFC,
  getAlumnoLicenciatura,
  insertaAlumno,
  getAlumnoBachillerato,
  insertaAlumnoBachillerato,
  // eslint-disable-next-line
  deleteAlumno,
  actualizaAlumno,
  aceptaRechazaAlumnos,
  revisarDocumentacion,
  revisarEstancia,
  insertaAlumnoBachilleratoIndividual,
} from "../helpers/services";

// Login

//Semestres
export const insertSemestre = async ({ commit }, datos) => {
  const { data } = await insertSemestres(datos);
  if (data.replyCode !== 200) {
    commit("setSemestres", []);
    return data;
  }
  let respuesta = await getSemestres();
  const {semestres} = respuesta.data
  const { nuevoSemestre } = data;
  // Modificar el state, commit de una mutacion
  commit("setSemestres", { nuevoSemestre: nuevoSemestre, numSemestres:semestres.length});  
  return data;
};

export const updateSemestre = async ({ commit }, datos) => {
  const { data } = await updateSemestres(datos);
  if (data.replyCode !== 200) {
    commit("updateSemestres", []);
    return data;
  }
  // Modificar el state, commit de una mutacion
  const {existeSemestre} = data
  commit("updateSemestres", existeSemestre);
  return data;
};

export const getSemestre = async ({ commit }) => {
  const { data } = await getSemestres();

  const { semestres } = data;
  // Modificar el state, commit de una mutacion
  commit("traeSemestres", semestres);
  return data
};

// Investigadores
// Listar investigadores
export const getAllInvestigators = async ({ commit }) => {
  const { data } = await getInvestigators();
  if (Object.keys(data).length == 0) {
    // Modificar state a vacio, commit de una mutacion
    commit("setAllInvestigators", []);
    return;
  }
  // const investigators = [];
  const { investigadores } = data;
  // Modificar el state, commit de una mutacion
  commit("setAllInvestigators", investigadores);
};

// Inserta investigador
export const insertInvestigators = async ({ commit }, values) => {
  const { data } = await insertInvestigator(values);
  if (data.replyCode !== 200) {
    // commit de una mutacion
    commit("insertInvestigators", []);
    return data;
  }
  values.idInvestigador = data.id;
  // Modificar el state, commit de una mutacion
  setTimeout(() => {
    commit("insertInvestigators", values);
  }, 3500);

  return data;
};

// Valida RFC Investigador
export const rfcInvestigador = async ({ commit }, values) => {
  const { data } = await validaRFC(values);
  if (data.replyCode !== 200) {
    // commit de una mutacion
    commit("rfcInvestigators", "");
    return data;
  }

  // Modificar el state, commit de una mutacion
  commit("rfcInvestigators", values);
  return data;
};

// Editar investigadores
export const updateInvestigators = async ({ commit }, values) => {
  const { data } = await updateInvestigator(values);
  if (data.replyCode !== 200) {
    // commit de una mutacion
    commit("updateInvestigators", []);
    return data;
  }

  // Modificar el state, commit de una mutacion
  commit("updateInvestigators", values);
  return data;
};

// Eliminar investigadores
export const deleteInvestigators = async ({ commit }, values) => {
  const { data } = await deleteInvestigator(values);
  if (data.replyCode !== 200) {
    // commit de una mutacion
    commit("deleteInvestigators", []);
    return data;
  }

  // Modificar el state, commit de una mutacion
  commit("deleteInvestigators", values);
  return data;
};

// Estancias

export const getAllEstancias = async ({ commit }) => {
  const { data } = await getEstancias();
  
  if (data == undefined || Object.keys(data).length == 0) {
    // Modificar state a vacio, commit de una mutacion
    commit("listEstancias", []);
    return;
  } 

  const { estancias } = data;
  commit("listEstancias", estancias);
  return estancias;
};

export const deleteEstancia = async ({ commit }, values) => {
  const { data } = await borraEstancia(values);
  if (data.replyCode != 200) {
    // commit de una mutacion
    commit("deleteEstancia", []);
    return data;
  }

  //modificar el state
  commit("deleteEstancia", values);
  return data;
};

export const revisaEstancias = async (context, values) => {
  const { data } = await revisarEstancia(values);
  return data;
};

// Alumnos

export const insertAlumno = async ({ commit }, values) => {
  const { data } = await insertaAlumno(values);
  if (data.replyCode !== 200) {
    // commit de una mutacion
    commit("insertAlumno", []);
    return data;
  }
  // Modificar el state, commit de una mutacion
  commit("insertAlumno", values);
  return data;
};

export const updateAlumno = async (context, values) => {
  const { data } = await actualizaAlumno(values);
  // if(data.replyCode !== 200) {
  //   // commit de una mutacion
  //   commit('insertAlumno', []);
  //   return data
  // }
  // // Modificar el state, commit de una mutacion
  // commit('insertAlumno', values);
  return data;
};

export const aceptaAlumnos = async (context, values) => {
  const { data } = await aceptaRechazaAlumnos(values);
  return data;
};

export const revisaDocs = async (context, values) => {
  const { data } = await revisarDocumentacion(values);
  return data;
};

export const insertAlumnoBachillerato = async (context, values) => {
  const { data } = await insertaAlumnoBachillerato(values);
  if (data.replyCode !== 200) {
    // commit de una mutacion
    return data;
  }
  // Modificar el state, commit de una mutacion
  return data;
};

export const insertAlumnoBachilleratoIndividual = async (context, values) => {
  const { data } = await insertaAlumnoBachilleratoIndividual(values);
  if (data.replyCode !== 200) {
    // commit de una mutacion
    return data;
  }
  // Modificar el state, commit de una mutacion
  return data;
};

export const getAlumnosLicenciatura = async ({ commit }) => {
  const { data } = await getAlumnoLicenciatura();
  if (Object.keys(data).length === 0) {
    // Modificar state a vacio, commit de una mutacion
    commit("setAlumnosLicenciatura", []);
    return;
  }
  const { alumnos } = data;
  // Modificar el state, commit de una mutacion
  commit("setAlumnosLicenciatura", alumnos);
};

export const getAlumnosBachillerato = async ({ commit }) => {
  const { data } = await getAlumnoBachillerato();
  if (Object.keys(data).length === 0) {
    // Modificar state a vacio, commit de una mutacion
    commit("setAlumnosBachillerato", []);
    return;
  }
  const { alumnos } = data;
  // Modificar el state, commit de una mutacion
  commit("setAlumnosBachillerato", alumnos);
};

/* eslint-disable */
export const deleteAlumnos = async ({ commit }, values) => {
  const { index } = values;
  delete values.index;
  const { data } = await deleteAlumno(values);
  if (data.replyCode !== 200) {
    // commit de una mutacion
    return data;
  }

  // Modificar el state, commit de una mutacion
  commit("deleteAlumnos", index);
  return data;
};


